import React, { useState } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, Collapse, Typography, Tooltip } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CallIcon from '@mui/icons-material/Call';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { faReadme } from '@fortawesome/free-brands-svg-icons';
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import LodingComponent from "./loding";
import { AuthProvider, useAuth } from "./AuthContext";
import Logout from "./Logout";
import Notification from "./Notification";
import AmountRequest from "./AmountRequest";
import SessionTimeout from "./SessionTimeout";
import { Work } from "@mui/icons-material";
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import CategoryIcon from '@mui/icons-material/Category';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import LaptopIcon from '@mui/icons-material/Laptop';
import BuildIcon from '@mui/icons-material/Build';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import PolicyIcon from '@mui/icons-material/Policy';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ListAltIcon from '@mui/icons-material/ListAlt';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PeopleIcon from '@mui/icons-material/People';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BadgeIcon from '@mui/icons-material/Badge';
import SettingsIcon from '@mui/icons-material/Settings';
import DescriptionIcon from '@mui/icons-material/Description';
import WorkIcon from '@mui/icons-material/Work';
import HouseIcon from '@mui/icons-material/House';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import ListIcon from '@mui/icons-material/List';
import AppleIcon from '@mui/icons-material/Apple';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import SyncIcon from '@mui/icons-material/Sync';
import Modal from '@mui/material/Modal';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import DonutSmallIcon from '@mui/icons-material/DonutSmall';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import ArticleIcon from '@mui/icons-material/Article';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Groups2Icon from '@mui/icons-material/Groups2';
//import { makeStyles } from '@mui/styles';
// // Company
// import CompanyIndex from './components/pages/company/Index';
// import CompanyCreate from "./components/pages/company/Create";
// import CompanyEdit from "./components/pages/company/Edit";

//AccountHead
import AccountHeadCreate from "./components/pages/AccountHead/Create";
import AccountHeadIndex from "./components/pages/AccountHead/Index";
import AccountHeadEdit from "./components/pages/AccountHead/Edit";

//Category
import ProductCategoryCreate from "./components/pages/ProductCategory/Create";
import ProductCategoryEdit from "./components/pages/ProductCategory/Edit";
import ProductCategoryIndex from "./components/pages/ProductCategory/Index";

//Product
import ProductCreate from "./components/pages/Product/Create";
import ProductEdit from "./components/pages/Product/Edit";
import ProductIndex from "./components/pages/Product/Index";

//Spareparts
import SpareCreate from "./components/pages/SpareParts/Create";
import SpareEdit from "./components/pages/SpareParts/Edit";
import SpareIndex from "./components/pages/SpareParts/index";

//Brand
import BrandCreate from "./components/pages/Brand/Create";
// import SpareEdit from "./components/pages/SpareParts/Edit";
import BrandIndex from "./components/pages/Brand/Index";

//Stock Transfer (Engineer Stock)
import EngineerStockIndex from "./components/pages/EngineerStock/index";
import EngineerStockTransfer from "./components/pages/EngineerStock/Stocktransfer";


//Staff
import StaffIndex from "./components/pages/Staff/index";
import StaffCreate from "./components/pages/Staff/create";
import StaffEdit from "./components/pages/Staff/Edit";

//User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//customer
import CustomerIndex from "./components/pages/Customer/Index";
import { CustomerCreate } from './components/pages/Customer/Create';
import CustomerEdit from "./components/pages/Customer/Edit";

//ServiceRequest
import ServiceRequestIndex from "./components/pages/ServiceRequest/Index";
import { ServiceRequestForm } from "./components/pages/ServiceRequest/servicecallcreate";
import ScheduledServicesIndex from "./components/pages/ServiceRequest/scheduledservices";
import Allocaterequest from "./components/pages/ServiceRequest/Taskschedule";
import Reschedulerequest from "./components/pages/ServiceRequest/Resheduletask";
import ServiceRequestFormEdit from "./components/pages/ServiceRequest/ServiceCallEdit";

//EngineerService
import WorkStatusIndex from "./components/pages/WorkUpdates/engineerwork";
import Invoice from "./components/pages/WorkUpdates/engineerwithinvoice";
import InvoiceEdit from "./components/pages/WorkUpdates/InvoiceEdit";
import EngineerWorkStatusIndex from "./components/pages/WorkUpdates/AssignedWorksheet";
import UpdateRequest from "./components/pages/Engineer/worksheet";

// Sale 
import SaleIndex from "./components/pages/Sale/SaleIndex";
import SIndex from "./components/pages/Sale/Index";
import SaleDetail from "./components/pages/Sale/SaleDeatils";
import SaleCreate from "./components/pages/Sale/Create";
import SaleEdit from "./components/pages/Sale/SaleEdit";

//Role
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";

//Report
import Stock from "./components/pages/Report/Stock";
import ServicedCall from "./components/pages/Report/ServicedCall";
import IncExpSummary from "./components/pages/Report/IncExpSummary";
import AMCSummary from "./components/pages/Report/AMCSummary";
import EngineerExpense from "./components/pages/Report/EngineerExpense";
import Callreport from "./components/pages/Report/CallSummary";
import CompanyPrint from "./components/pages/Report/callreportPrints";
import { CallReportCreate } from "./components/pages/Report/Create";
import Ledger from "./components/pages/Report/Ledger";
import CashBook from "./components/pages/Report/CashBook";
import EngineerWorkReport from "./components/pages/Report/EngineerWorkTrack";

//Engineer Expense Sheet 
import ExpenseEntryPage from "./components/pages/DailyExpenseEntry/testcreate";
import Index from "./components/pages/DailyExpenseEntry/Index";
import ExpenseEditPage from "./components/pages/DailyExpenseEntry/Edit";
import OfficeIndex from "./components/pages/DailyExpenseEntry/ExpensesheetOffice";
import OfficeEditPage from "./components/pages/DailyExpenseEntry/officeedit";

//Expense Type for Engineers
import ExpenseTypeIndex from "./components/pages/ExpenseType/Index";
import ExpenseCreate from "./components/pages/ExpenseType/Create";
import ExpenseEdit from "./components/pages/ExpenseType/Edit";

//Office Expense
import OfficeExpenseCreate from "./components/pages/Expense/Create";
import OfficeExpenseIndex from "./components/pages/Expense/Index";
import OfficeExpenseEdit from "./components/pages/Expense/Edit";

//Receipt
import ReceiptCreate from "./components/pages/Receipt/Create";
import ReceiptIndex from "./components/pages/Receipt/Index";
import ReceiptEdit from "./components/pages/Receipt/Edit";
//Amount requested
import RequestedAmountPage from "./components/pages/RequestedAmount/Create";
//Return Spare
import ReturnIndex from "./components/pages/SpareReturn/Index";
//Home
import Home from "./components/pages/Home";

//product model
import ModelIndex from "./components/pages/ProductModel/Index";
import ProductModelCreate from "./components/pages/ProductModel/Create";
import ModelEdit from "./components/pages/ProductModel/Edit";

// DAIRY & WEEKLY SCHEDULE
import WeeklySchedule from "./components/pages/StaffWeeklySchedule/Create";
import StaffDairy from "./components/pages/StaffDairy/Create";

// Attendance 
import AttendanceIndex from "./components/pages/AttendanceStatus/Index";
import AttendancePage from "./components/pages/AttendanceSheet/Create";
import MonthlyAttendancePage from "./components/pages/Report/Monthlyattendance";

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [userOpen, setuserOpen] = useState(false);
  const [serviceOpen, setserviceOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };


  const handleUserClick = () => {
    setuserOpen(!userOpen);
  };


  const handleserviceClick = () => {
    setserviceOpen(!serviceOpen);
  };


  const { companyName, companyId, isSuperAdmin, superCompanyId, roleName, userId, username } = useAuth();


  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Router>
      <AuthProvider>
        <SessionTimeout />
        {/* <AppBar position="static" style={{ backgroundColor: '#36454F' }}> */}
        <AppBar position="static" style={{ backgroundColor: '#090040', height: '50px' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
              <MenuIcon />
            </IconButton>

            <Typography variant="h6" component="div" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Link to="/Home" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
                  <FiHome style={{ marginRight: '8px' }} />
                  {/* <Typography variant="h6" className="dual-text" component="div" style={{ marginLeft: '16px', fontWeight: 'bolder' }}> */}
                  <Typography variant="h6" component="div" style={{ marginLeft: '16px', fontWeight: 'bolder', fontFamily: 'monospace' }}>
                    {companyName}
                  </Typography>
                  <Typography variant="h2" className="dual-text" component="div" style={{ marginLeft: '50px', fontWeight: 'bolder' }}>
                    {username}
                  </Typography>
                </Link>
              </div>
              {roleName !== "Engineer" && roleName !== "Receptionist" && (
                <>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div className="white-icon"><Notification /></div>
                    <div className="white-icon"><AmountRequest /></div>
                    <div className="white-icon" style={{ marginTop: '15px' }}><Logout /></div>
                  </div>
                </>
              )}

              {roleName !== "CompanyAdmin" && (
                <>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: '-20px' }}>
                    <Link to="/RequestedAmountPage">
                      <div className="white-icon">
                        <Tooltip title="Request Amount">
                          <CurrencyExchangeIcon style={{ marginTop: '15px', color: 'lightyellow' }} />
                        </Tooltip>
                      </div>
                    </Link>
                    <div className="white-icon" style={{ marginTop: '15px', marginLeft: '20px' }}>
                      <Logout />
                    </div>
                  </div>
                </>
              )}
            </Typography>
          </Toolbar>
        </AppBar>

        {roleName !== "Engineer" && roleName !== "Receptionist" && (
          <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}>
            <List>
              {/* <h4 className="dual-tone-text" style={{ marginLeft: '20px', fontWeight: 'bolder' }}> {companyName}</h4> */}

              <ListItem button component={NavLink} to="/Home" activeClassName="selected" onClick={handleDrawerClose}>
                <HouseIcon style={{ color: 'darkslateblue' }} /> <ListItemText primary="HOME" style={{ marginLeft: '3px' }} />
              </ListItem>

              <ListItem button onClick={handleMasterClick}>

                <ListItemText primary="MASTER" />
                {masterOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>

              <Collapse in={masterOpen} timeout="auto" unmountOnExit>

                <List style={{ paddingLeft: '16px', fontWeight: 'bolder', fontSize: '12px' }}>

                  <ListItem button component={NavLink} to="/CustomerIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <PersonIcon style={{ color: 'blueviolet', fontWeight: 'bolder' }} />
                    {/* <ListItemText primary="Customer" style={{ marginLeft: '3px' }}  */}
                    <ListItemText
                      primary="Customer"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/ProductCategoryIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <LaptopIcon style={{ color: 'darkgoldenrod' }} />
                    {/* <ListItemText primary="Category" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Category"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/BrandIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <AppleIcon style={{ color: 'cadetblue' }} />
                    {/* <ListItemText primary="Brand" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Brand"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/ModelIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <DonutSmallIcon style={{ color: 'darkmagenta' }} />
                    {/* <ListItemText primary="Model" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Model"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/SpareIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <BuildIcon style={{ color: 'grey' }} />
                    {/* <ListItemText primary="Spare Parts" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Spare Parts"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/AccountHeadIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <AccountBalanceIcon style={{ color: 'darkkhaki' }} />
                    {/* <ListItemText primary="Account Head" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Account Head"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/ExpenseTypeIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <ListAltIcon style={{ color: 'red' }} />
                    {/* <ListItemText primary="E-Type" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="E-Type"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/WeeklySchedule" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px', marginLeft: '5px' }}>
                    <FontAwesomeIcon icon={faCalendarDays} style={{ color: 'darkorchid', height: '20px' }} />
                    {/* <ListItemText primary="Weekly Schedule" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Weekly Schedule"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/StaffDairy" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <CalendarMonthIcon style={{ color: 'darkred', height: '25px' }} />
                    {/* <ListItemText primary="Staff Diary" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Staff Diary"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/AttendanceIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <MoreHorizIcon style={{ color: 'darkorchid', height: '20px' }} />
                    {/* <ListItemText primary="Attendace Status" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Attendace Status"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/AttendancePage" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <Groups2Icon style={{ color: 'black', height: '20px' }} />
                    {/* <ListItemText primary="Attendace Sheet" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Attendace Sheet"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>


                </List>

              </Collapse>

              <ListItem button component={NavLink} to="/ServiceRequestForm" activeClassName="selected" onClick={handleDrawerClose} >
                <CallIcon style={{ color: "green" }} />  <ListItemText primary="CALL LOG " style={{ marginLeft: '3px' }} />
              </ListItem>

              <ListItem button onClick={handleserviceClick}>
                <ListItemText primary="TRANSACTION" />
                {serviceOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>

              <Collapse in={serviceOpen} timeout="auto" unmountOnExit>

                <List style={{ paddingLeft: '16px' }}>

                  <ListItem button component={NavLink} to="/ServiceRequestIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <DescriptionIcon style={{ color: 'darkred' }} />
                    {/* <ListItemText primary="Task Schedule" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Task Schedule"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/ScheduledServicesIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <ScheduleIcon style={{ color: 'darkblue' }} />
                    {/* <ListItemText primary="Scheduled Jobs" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Scheduled Jobs"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/SIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <ShoppingBasketIcon style={{ color: 'darkseagreen' }} />
                    {/* <ListItemText primary="Sale" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Sale"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/CompanyPrint" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <PermPhoneMsgIcon style={{ color: 'darkblue' }} />
                    {/* <ListItemText primary="CallReport" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Call Report"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/EngineerStockTransfer" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <SwapHorizIcon style={{ color: 'brown' }} />
                    {/* <ListItemText primary="Stock Transfer" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Stock Transfer"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/ReturnIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <SyncIcon style={{ color: 'darkred' }} />
                    {/* <ListItemText primary="Spare Return" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Spare Return"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OfficeIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <PolicyIcon style={{ color: 'darkturquoise' }} />
                    {/* <ListItemText primary="Claims" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Claims"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OfficeExpenseIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <AttachMoneyIcon style={{ color: 'darkgoldenrod' }} />
                    {/* <ListItemText primary="Office Expense" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Office Expense"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/ReceiptIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <RequestQuoteIcon style={{ color: 'darkgoldenrod' }} />
                    {/* <ListItemText primary="Receipt" /> */}
                    <ListItemText
                      primary="Receipt"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                </List>

              </Collapse>
              <ListItem button component={NavLink} to="/EngineerWorkReport" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                <ArticleIcon style={{ color: 'darkgoldenrod' }} /> <ListItemText primary="WORK REPORT" />
              </ListItem>
              <ListItem button onClick={handleReportClick}>

                <ListItemText primary="REPORT" />
                {reportOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>

              <Collapse in={reportOpen} timeout="auto" unmountOnExit>

                <List style={{ paddingLeft: '16px' }}>
                  <ListItem button component={NavLink} to="/Ledger" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <LibraryBooksIcon style={{ color: 'blue' }} />
                    {/* <ListItemText primary="Ledger" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Ledger"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>
                  {/* <ListItem button component={NavLink} to="/CashBook" activeClassName="selected" onClick={handleDrawerClose}>
                    <AccountBalanceWalletIcon style={{ color: 'darkolivegreen' }} /><ListItemText primary="Cash Book" style={{ marginLeft: '3px' }} />
                  </ListItem> */}
                  <ListItem button component={NavLink} to="/Stock" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <FontAwesomeIcon icon={faChartLine} style={{ color: 'blueviolet' }} />
                    {/* <ListItemText primary="Stock" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Stock"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>
                  <ListItem button component={NavLink} to="/Callreport" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <FontAwesomeIcon icon={faReadme} style={{ color: 'darkmagenta' }} />
                    {/* <ListItemText primary="Call Summary" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Call Summary"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>
                  <ListItem button component={NavLink} to="/ServicedCall" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <FontAwesomeIcon icon={faReadme} style={{ color: 'darkred' }} />
                    {/* <ListItemText primary="Serviced Jobs" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Serviced Jobs"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/AMCSummary" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <FontAwesomeIcon icon={faReadme} style={{ color: 'darkgreen' }} />
                    {/* <ListItemText primary="AMC " style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="AMC"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/IncExpSummary" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <ArticleIcon style={{ color: 'darkgoldenrod' }} />
                    {/* <ListItemText primary="INC/EXP" /> */}
                    <ListItemText
                      primary="INC/EXP"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/EngineerExpense" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <AccountBalanceWalletIcon style={{ color: 'darkgoldenrod' }} />
                    {/* <ListItemText primary="Engineer EXP" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Engineer EXP"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/MonthlyAttendancePage" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <Groups2Icon style={{ color: 'darkblue' }} />
                    {/* <ListItemText primary="Attendance Report" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Attendance Report"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>
                </List>

              </Collapse>

              <ListItem button onClick={handleUserClick}>

                <ListItemText primary="USER" />
                {userOpen ? <ExpandLess /> : <ExpandMore />}

              </ListItem>

              <Collapse in={userOpen} timeout="auto" unmountOnExit>

                <List style={{ paddingLeft: '16px' }}>

                  <ListItem button component={NavLink} to="/StaffIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <PeopleIcon style={{ color: 'blueviolet', fontWeight: 'bolder' }} />
                    {/* <ListItemText primary="Staff" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Staff"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/UserIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <AccountCircleIcon style={{ color: 'blue' }} />
                    {/* <ListItemText primary="User" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="User"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/RoleIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <BadgeIcon style={{ color: 'darkorange' }} />
                    {/* <ListItemText primary="Role" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Role"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                  <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <SettingsIcon style={{ color: 'darkolivegreen' }} />
                    {/* <ListItemText primary="Change Password" style={{ marginLeft: '3px' }} /> */}
                    <ListItemText
                      primary="Change Password"
                      primaryTypographyProps={{
                        style: {
                          marginLeft: '3px',
                          color: '#090040',
                          fontFamily: 'monospace',
                          textTransform: 'uppercase',
                        },
                      }}
                    />
                  </ListItem>

                </List>

              </Collapse>

            </List>

          </Drawer>
        )}

        {roleName !== "CompanyAdmin" && roleName !== "Receptionist" && (
          <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}>
            <br></br>

            {/* <h4 className="dual-tone-text" style={{ marginLeft: '20px', fontWeight: 'bolder' }}> {companyName}</h4> */}
            <ListItem button component={NavLink} to="/Home" activeClassName="selected" onClick={handleDrawerClose}>
              <HouseIcon style={{ color: 'darkslateblue' }} />
              {/* <ListItemText primary="HOME" style={{ marginLeft: '3px' }} /> */}
              <ListItemText
                primary="HOME"
                primaryTypographyProps={{
                  style: {
                    marginLeft: '3px',
                    color: '#090040',
                    fontFamily: 'monospace',
                    textTransform: 'uppercase',
                  },
                }}
              />
            </ListItem>
            <ListItem button component={NavLink} to="/SpareIndex" activeClassName="selected" onClick={handleDrawerClose}>
              <BuildIcon style={{ color: 'grey' }} />
              {/* <ListItemText primary="Spare Parts" style={{ marginLeft: '3px' }} /> */}
              <ListItemText
                primary="Spare Parts"
                primaryTypographyProps={{
                  style: {
                    marginLeft: '3px',
                    color: '#090040',
                    fontFamily: 'monospace',
                    textTransform: 'uppercase',
                  },
                }}
              />
            </ListItem>
            <ListItem button component={NavLink} to="/EngineerWorkStatusIndex" activeClassName="selected" onClick={handleDrawerClose}>
              <WorkIcon style={{ color: 'darkmagenta' }} />
              {/* <ListItemText primary="WORK" style={{ marginLeft: '3px' }} /> */}
              <ListItemText
                primary="WORK"
                primaryTypographyProps={{
                  style: {
                    marginLeft: '3px',
                    color: '#090040',
                    fontFamily: 'monospace',
                    textTransform: 'uppercase',
                  },
                }}
              />
            </ListItem>

            <ListItem button component={NavLink} to="/SIndex" activeClassName="selected" onClick={handleDrawerClose}>
              <ShoppingBasketIcon style={{ color: 'darkseagreen' }} />
              {/* <ListItemText primary="SALE" style={{ marginLeft: '3px' }} /> */}
              <ListItemText
                primary="SALE"
                primaryTypographyProps={{
                  style: {
                    marginLeft: '3px',
                    color: '#090040',
                    fontFamily: 'monospace',
                    textTransform: 'uppercase',
                  },
                }}
              />
            </ListItem>

            <ListItem button component={NavLink} to="/CompanyPrint" activeClassName="selected" onClick={handleDrawerClose}>
              <PermPhoneMsgIcon style={{ color: 'darkblue' }} />
              {/* <ListItemText primary="CallReport" style={{ marginLeft: '3px' }} /> */}
              <ListItemText
                primary="Call Report"
                primaryTypographyProps={{
                  style: {
                    marginLeft: '3px',
                    color: '#090040',
                    fontFamily: 'monospace',
                    textTransform: 'uppercase',
                  },
                }}
              />
            </ListItem>

            <ListItem button component={NavLink} to="/EngineerStockIndex" activeClassName="selected" onClick={handleDrawerClose}>
              <TrendingUpIcon style={{ color: 'blueviolet' }} />
              {/* <ListItemText primary="E STOCK" style={{ marginLeft: '3px' }} /> */}
              <ListItemText
                primary="E STOCK"
                primaryTypographyProps={{
                  style: {
                    marginLeft: '3px',
                    color: '#090040',
                    fontFamily: 'monospace',
                    textTransform: 'uppercase',
                  },
                }}
              />
            </ListItem>

            <ListItem button component={NavLink} to="/Index" activeClassName="selected" onClick={handleDrawerClose}>
              <AttachMoneyIcon style={{ color: 'darkgoldenrod' }} />
              {/* <ListItemText primary="EXPENSE SHEET" style={{ marginLeft: '3px' }} /> */}
              <ListItemText
                primary="EXPENSE SHEET"
                primaryTypographyProps={{
                  style: {
                    marginLeft: '3px',
                    color: '#090040',
                    fontFamily: 'monospace',
                    textTransform: 'uppercase',
                  },
                }}
              />
            </ListItem>

            <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" onClick={handleDrawerClose}>
              <SettingsIcon style={{ color: 'darkolivegreen' }} />
              {/* <ListItemText primary="CHANGE PASSWORD" style={{ marginLeft: '3px' }} /> */}
              <ListItemText
                primary="CHANGE PASSWORD"
                primaryTypographyProps={{
                  style: {
                    marginLeft: '3px',
                    color: '#090040',
                    fontFamily: 'monospace',
                    textTransform: 'uppercase',
                  },
                }}
              />
            </ListItem>

          </Drawer>
        )}


        {roleName !== "CompanyAdmin" && roleName !== "Engineer" && (
          <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}>

            {/* <h4 className="dual-tone-text" style={{ marginLeft: '20px', fontWeight: 'bolder' }}> {companyName}</h4> */}
            <ListItem button component={NavLink} to="/Home" activeClassName="selected" onClick={handleDrawerClose}>
              <HouseIcon style={{ color: 'darkslateblue' }} /> <ListItemText primary="HOME" style={{ marginLeft: '3px' }} />
            </ListItem>


            <ListItem button component={NavLink} to="/ServiceRequestForm" activeClassName="selected" onClick={handleDrawerClose}>
              <CallIcon style={{ color: "green" }} />  <ListItemText primary="CALL LOG " style={{ marginLeft: '3px' }} />
            </ListItem>

            <ListItem button onClick={handleMasterClick}>
              <ListItemText primary="MASTER" />
              {masterOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={masterOpen} timeout="auto" unmountOnExit>

              <List style={{ paddingLeft: '16px', fontWeight: 'bolder', fontSize: '12px' }}>

                <ListItem button component={NavLink} to="/CustomerIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PersonIcon style={{ color: 'blueviolet', fontWeight: 'bolder' }} />  <ListItemText primary="Customer" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ProductCategoryIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <LaptopIcon style={{ color: 'darkcyan' }} /><ListItemText primary="Category" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/BrandIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AppleIcon style={{ color: 'cadetblue' }} /> <ListItemText primary="Brand" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ModelIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <DonutSmallIcon style={{ color: 'darkmagenta' }} /> <ListItemText primary="Spare Parts" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SpareIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <BuildIcon style={{ color: 'grey' }} /> <ListItemText primary="Spare Parts" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/AccountHeadIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AccountBalanceIcon style={{ color: 'darkkhaki' }} /><ListItemText primary="Account Head" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ExpenseTypeIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ListAltIcon style={{ color: 'red' }} /> <ListItemText primary="E-Type" style={{ marginLeft: '3px' }} />
                </ListItem>

              </List>

            </Collapse>


            <ListItem button component={NavLink} to="/ServiceRequestIndex" activeClassName="selected" onClick={handleDrawerClose}>
              <DescriptionIcon style={{ color: 'darkred' }} /><ListItemText primary="Requested Service" style={{ marginLeft: '3px' }} />
            </ListItem>

            <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" onClick={handleDrawerClose}>
              <SettingsIcon style={{ color: 'darkolivegreen' }} /><ListItemText primary="Change Password" style={{ marginLeft: '3px' }} />
            </ListItem>

          </Drawer>
        )}

        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/Home" exact component={Home} />

          {/* Company */}
          {/* <Route path="/CompanyIndex" component={CompanyIndex} />
          <Route path="/CompanyCreate" component={CompanyCreate} />
          <Route path="/CompanyEdit/:id" component={CompanyEdit} /> */}

          {/* Staff */}
          <Route path="/StaffIndex" component={StaffIndex} />
          <Route path="/StaffCreate" component={StaffCreate} />
          <Route path="/StaffEdit/:id" component={StaffEdit} />
          {/* User */}
          <Route path="/UserIndex" component={UserIndex} />
          <Route path="/UserCreate" component={UserCreate} />
          <Route path="/UserEdit/:id" component={UserEdit} />
          <Route path="/UserDetail/:id" component={UserDetail} />
          <Route path="/PasswordChange" component={PasswordChange} />

          {/* Role */}
          <Route path="/RoleIndex" component={RoleIndex} />
          <Route path="/RoleDetail/:id" component={RoleDetail} />

          {/* Customer */}
          <Route path="/CustomerIndex" component={CustomerIndex} />
          <Route path="/CustomerCreate" component={CustomerCreate} />
          <Route path="/CustomerEdit/:id" component={CustomerEdit} />

          {/* ProductCategory */}
          <Route path="/ProductCategoryIndex" component={ProductCategoryIndex} />
          <Route path="/ProductCategoryCreate" component={ProductCategoryCreate} />
          <Route path="/ProductCategoryEdit/:id" component={ProductCategoryEdit} />

          {/* Spareparts */}
          <Route path="/SpareIndex" component={SpareIndex} />
          <Route path="/SpareCreate" component={SpareCreate} />
          <Route path="/SpareEdit/:id" component={SpareEdit} />

          {/* Product */}
          <Route path="/BrandIndex" component={BrandIndex} />
          <Route path="/BrandCreate" component={BrandCreate} />
          <Route path="/ProductEdit/:id" component={ProductEdit} />

          {/* ServiceRequest */}
          <Route path="/ServiceRequestIndex" component={ServiceRequestIndex} />
          <Route path="/ServiceRequestForm" component={ServiceRequestForm} />
          <Route path="/ServiceRequestFormEdit/:id" component={ServiceRequestFormEdit} />
          <Route path="/Allocaterequest/:id" component={Allocaterequest} />
          <Route path="/ScheduledServicesIndex" component={ScheduledServicesIndex} />
          <Route path="/invoice/:id" component={Invoice} />
          <Route path="/Reschedulerequest/:id" component={Reschedulerequest} />
          {/* <Route path="/InvoiceEdit/:id" component={InvoiceEdit} /> */}

          {/* EngineerWork */}
          <Route path="/WorkStatusIndex" component={WorkStatusIndex} />
          <Route path="/EngineerWorkStatusIndex" component={EngineerWorkStatusIndex} />
          <Route path="/UpdateRequest/:id" component={UpdateRequest} />

          {/* EngineerStock */}
          <Route path="/EngineerStockIndex" component={EngineerStockIndex} />
          <Route path="/EngineerStockTransfer" component={EngineerStockTransfer} />

          {/* Sale */}
          <Route path="/SaleIndex" component={SaleIndex} />
          <Route path="/SIndex" component={SIndex} />
          <Route path="/SaleCreate" component={SaleCreate} />
          <Route path="/SaleDetail/:id" component={SaleDetail} />
          <Route path="/SaleEdit/:id" component={SaleEdit} />

          {/* AccountHead*/}
          <Route path="/AccountHeadIndex" component={AccountHeadIndex} />
          <Route path="/AccountHeadCreate" component={AccountHeadCreate} />
          <Route path="/AccountHeadEdit/:id" component={AccountHeadEdit} />

          {/* Expense Entry for Engineers */}
          <Route path="/Index" component={Index} />
          <Route path="/ExpenseEntryPage" component={ExpenseEntryPage} />
          <Route path="/ExpenseEditPage/:id" component={ExpenseEditPage} />

          {/* Expense Claim Section By Manager */}
          <Route path="/OfficeIndex" component={OfficeIndex} />
          <Route path="/OfficeEditPage/:id" component={OfficeEditPage} />

          {/* Expense Type */}
          <Route path="/ExpenseTypeIndex" component={ExpenseTypeIndex} />
          <Route path="/ExpenseCreate" component={ExpenseCreate} />
          <Route path="/ExpenseEdit/:id" component={ExpenseEdit} />

          {/* Expense By Office */}
          <Route path="/OfficeExpenseIndex" component={OfficeExpenseIndex} />
          <Route path="/OfficeExpenseCreate" component={OfficeExpenseCreate} />
          <Route path="/OfficeExpenseEdit/:id" component={OfficeExpenseEdit} />

          {/* Amount requested */}
          {/* <Route path="/ReceiptIndex" component={ReceiptIndex} /> */}
          <Route path="/RequestedAmountPage" component={RequestedAmountPage} />

          {/* Spare Return */}
          <Route path="/ReturnIndex" component={ReturnIndex} />

          {/* Product Model */}
          <Route path="/ModelIndex" component={ModelIndex} />
          <Route path="/ProductModelCreate" component={ProductModelCreate} />
          <Route path="/ModelEdit/:id" component={ModelEdit} />

          {/* Receipt */}
          <Route path="/ReceiptIndex" component={ReceiptIndex} />
          <Route path="/ReceiptCreate" component={ReceiptCreate} />
          <Route path="/ReceiptEdit/:id" component={ReceiptEdit} />

          {/* WeeklySchedule */}
          {/* <Route path="/ReceiptIndex" component={ReceiptIndex} /> */}
          <Route path="/WeeklySchedule" component={WeeklySchedule} />
          <Route path="/StaffDairy" component={StaffDairy} />
          {/* <Route path="/ReceiptEdit/:id" component={ReceiptEdit} /> */}

          {/* Report  */}
          <Route path="/Ledger" component={Ledger} />
          {/* <Route path="/CashBook" component={CashBook} /> */}
          <Route path="/Stock" component={Stock} />
          <Route path="/Callreport" component={Callreport} />
          <Route path="/ServicedCall" component={ServicedCall} />
          <Route path="/AMCSummary" component={AMCSummary} />
          <Route path="/EngineerExpense" component={EngineerExpense} />
          <Route path="/CompanyPrint" component={CompanyPrint} />
          <Route path="/CallReportCreate/:id" component={CallReportCreate} />
          {/* <Route path="/PackingList" component={PackingList} />
          <Route path="/Ledger" component={Ledger} />
          <Route path="/LedgerIncExp" component={LedgerIncExp} /> */}
          <Route path="/IncExpSummary" component={IncExpSummary} />
          <Route path="/EngineerWorkReport" component={EngineerWorkReport} />
          <Route path="/MonthlyAttendancePage" component={MonthlyAttendancePage} />

          {/* Attendance */}
          <Route path="/AttendanceIndex" component={AttendanceIndex} />
          <Route path="/AttendancePage" component={AttendancePage} />

          {/* 404 Not Found */}

        </Switch>
      </AuthProvider >
    </Router>
  );
};

export default App;

